module.exports = __webpack_public_path__ + "img/laColombe.2588c225.jpg";